import React from 'react';

import delv from 'dlv';
import { Link } from 'react-router';
import styled from 'styled-components';

import { Picture } from 'components/picture';

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  position: relative;
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 2.5rem 0;
  ${Styles.desktop} {
    grid-template-columns: ${props =>
      React.Children.count(props.children) === 2 ? '1fr 1fr' : '1fr 1fr 1fr 1fr'};
  }
  ${Styles.mobile} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 3.5rem;
    padding: 1.5rem 0;
  }
  ${Styles.mobileSmall} {
    grid-template-columns: 1fr;
  }
`;

const CardTitle = styled.h4``;

const CardContent = styled.div`
  ${CardTitle} {
    margin: 0;
    padding: 0;
    line-height: 1.5rem;
    font-weight: 900;
  }
  display: grid;
  grid-template-rows: ${Object.prototype.hasOwnProperty.call(
    React.Children.hasOwnProperty,
    'linkText'
  )
    ? 'auto 1fr 40px'
    : 'auto 1fr'};
  height: 100%;
  padding: 1.5rem 1rem;
  ${Styles.mobile} {
    padding: 1.5rem 0;
  }
  ${Styles.mobileSmall} {
    display: block;
    grid-column: 1;
    grid-template-rows: auto auto auto;
    height: auto;
    padding: 0;
  }
`;

const Card = styled(Link)`
  text-decoration: none;
  color: ${Styles.color.black};
  background: ${Styles.color.grey.five};
  border-start-start-radius: 0;
  border-start-end-radius: 0;
  border-end-end-radius: 4px;
  border-end-start-radius: 4px;
  display: grid;
  grid-template-rows: auto 1fr;
  ${Styles.mobile} {
    background: none;
    padding: 0;
  }
  ${Styles.mobileSmall} {
    grid-template-rows: auto;
    grid-template-columns: 1fr 25vw;
    grid-auto-flow: dense;
    grid-gap: 1.5rem;
  }
`;

const CardImageContainer = styled.div`
  position: relative;
  width: 100%;
  padding-block-end: 75%;
  overflow: hidden;
  border-start-start-radius: 4px;
  border-start-end-radius: 4px;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  ${Styles.mobileSmall} {
    grid-column: 2;
    width: 25vw;
    height: 25vw;
    align-self: center;
    padding-block-end: 0;
    border-radius: 4px;
    margin-block-end: 1rem;
  }
`;
const CardImage = styled(Picture)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: absolute;
`;

const CardBody = styled.div`
  margin: 0.5rem 0;
`;

const LinkText = styled.div`
  text-align: start;
  font-weight: 700;
  align-self: end;
  color: ${Styles.color.primary};
  font-size: 1rem;
  ${Styles.mobile} {
    font-size: 0.9375rem;
  }
`;
export class PreviewWidget extends React.Component {
  render() {
    return (
      <Section>
        {this.props.previewContent.map((card, k) => {
          // @todo remove this once Sanity data as been migrated to use localizedLinkURL
          const url = delv(card, 'localizedLinkURL.locale') || card?.linkURL;
          return (
            <Card key={`card${k}`} to={url}>
              <CardImageContainer>
                <CardImage image={delv(card, 'previewImage.locale')} />
              </CardImageContainer>
              <CardContent>
                {card.titleText && <CardTitle>{delv(card, 'titleText.locale')}</CardTitle>}
                {card.bodyText && <CardBody>{delv(card, 'bodyText.locale')}</CardBody>}
                {card.linkText && <LinkText>{delv(card, 'linkText.locale')}</LinkText>}
              </CardContent>
            </Card>
          );
        })}
      </Section>
    );
  }
}
